import { Scope } from '@/domain/external-invitation/entities/external-invitation.entity';
import { InviteCategory } from '@/domain/external-invitation/entities/invitation-category';

import { SCOPES } from './data/scopes';

const categoryByScope = prepareObjectCategoryByScope();

export function getCategoryFromScope(scope: Scope): InviteCategory {
  return categoryByScope[scope];
}

type CategoryByScope = {
  [key in Scope]: InviteCategory;
};

function prepareObjectCategoryByScope(): CategoryByScope {
  let result;
  result = Object.values(SCOPES)
    .map((sectors) =>
      Object.values(sectors).map((sector) =>
        Object.entries(sector).map(([category, scope]) => [scope, category]),
      ),
    )
    .flat(2);
  result = Object.fromEntries(result);
  return result;
}
